import React, { useEffect, useState } from 'react'

import { Box, Button, ButtonGroup, ClickAwayListener, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Popper, Tooltip, Typography } from '@mui/material'
import './Tour.css'

export interface TourProps {
  open?: boolean | "" | undefined
  onClose?: () => void
}

const steps = [
  {
    target: "[data-tour='home-logo']",
    title: 'Home',
    content: 'Click on the logo to go back to the home page',
  },
  {
    target: "[data-tour='address-input']",
    title: 'Address Search',
    content: 'Enter the address you want to generate an accurate estimate for',
  },
  {
    target: "[data-tour='address-customize']",
    title: 'Address Advanced Search',
    content: 'You can customize the search by adding beds, baths, and sqft, if it needs corrections',
  },
  {
    target: "[data-tour='menu-new-estimate']",
    title: 'New Estimate',
    content: 'Click here to start a new estimate',
  },
  {
    target: "[data-tour='menu-help']",
    title: 'Help',
    content: 'Click here to get help',
  },
  {
    target: "[data-tour='menu-tour']",
    title: 'Tour',
    content: 'Click here to start the tour again',
  }
]

const Tour = (props: TourProps) => {
  const [activeStep, setActiveStep] = useState(0)
  const [anchorEl, setAnchorEl] = useState<Element>()
  const [done, setDone] = useState(true)

  useEffect(() => {
    if (props.open && activeStep > -1) {
      setActiveStep(parseInt(localStorage.getItem('tourStatus') ?? '0'))
      const targetElement = document.querySelector(steps[activeStep].target);
      if (targetElement) {
        setAnchorEl(targetElement)
        targetElement.classList.add('tour-highlight');
      }
    }
    return () => {
      cleanupHighlight()
    }
  }, [props.open, activeStep])

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      const step = activeStep + 1
      setActiveStep(step)
      localStorage.setItem('tourStatus', (step).toString())
    } else {
      setDone(false)
      props.onClose && props.onClose()
      localStorage.setItem('tourStatus', '-1')
    }
  }

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep(activeStep - 1)
    }
  }

  const handleClose = () => {
    cleanupHighlight()
    setDone(false)
    props.onClose && props.onClose()
  }
  const cleanupHighlight = () => {
    steps.forEach(step => {
      const element = document.querySelector(step.target)
      if (element) {
        element.classList.remove('tour-highlight')
      }
    })
  }

  return (
    activeStep > -1 ? <Popper open={props.open ? true : false} anchorEl={anchorEl} placement="bottom" modifiers={[{ name: 'offset', options: { offset: [0, 1] } }]}>
      <ClickAwayListener onClickAway={handleClose}>
        <Paper elevation={3} style={{ padding: '5px 16px', maxWidth: '350px', backgroundColor: '#fff' }}>
          <Typography variant="h6" gutterBottom><strong>{steps[activeStep].title}</strong></Typography>
          <Typography variant="body1" gutterBottom>{steps[activeStep].content}</Typography>
          <Box mt={2} display="flex" justifyContent="space-between" width="100%">
            <ButtonGroup variant="outlined" size="small" fullWidth>
              <Button onClick={handleBack} disabled={activeStep === 0} sx={{ display: 'none' }}>Back</Button>
              <Button onClick={handleNext}>{activeStep === steps.length - 1 ? 'Finish' : 'Next'}</Button>
            </ButtonGroup>
          </Box>
        </Paper>
      </ClickAwayListener>
    </Popper> : <></>
  )
}

export default Tour
